import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';

class PasswordResetStore extends EventDrivenStore {
  constructor() {
    const initialState = {
      email: null,
      newPassword: '',
      confirmPassword: '',
      loading: false,
      error: null,
      success: false,
      isMigration: false,
      legacyData: null
    };
    super('passwordReset', initialState, {
      useLocalStorage: false
    });

    this.updateState({
      ...initialState
    });
  }

  async setupEvents() {
    this.on(constants.EVENTS.PASSWORD_RESET.SHOW_NEW_PASSWORD_INPUT, (data) => {
      this.state.email = data.email;
      this.state.isMigration = data.isMigration || false;
      this.state.legacyData = data.legacyData || null;
      this.state.newPassword = '';
      this.state.confirmPassword = '';
      this.state.error = null;
      this.state.success = false;
    });

    this.on(constants.EVENTS.PASSWORD_RESET.SUBMIT_NEW_PASSWORD, () => {
      this.state.loading = true;
      this.state.error = null;
    });

    this.on(constants.EVENTS.USER.UPDATE_SUCCESS, () => {
      this.state.loading = false;
      this.state.success = true;
    });

    this.on(constants.EVENTS.USER.UPDATE_ERROR, (error) => {
      this.state.error = error?.message || error;
      this.state.loading = false;
    });

    this.on(constants.EVENTS.PASSWORD_RESET.RESET_SUCCESS, () => {
      this.updateState({ ...this.initialState });
    });

    this.on(constants.EVENTS.PASSWORD_RESET.CANCEL, () => {
      this.updateState({ ...this.initialState });
    });
  }
}

export default PasswordResetStore;
